"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const prop_types_1 = __importDefault(require("prop-types"));
const totangoTheme_1 = require("../../theme/totangoTheme");
require("../../styles/components/click-to-edit.less");
const useStyles = (0, core_1.makeStyles)(() => ({
    container: {
        display: 'block',
        verticalAlign: 'baseline',
        cursor: 'text',
    },
    inputRoot: {
        // bumps up specificity so it overrides the default 40px
        '&&': {
            minHeight: 'auto',
            height: 'auto',
        },
    },
    input: {
        padding: 0,
        margin: 0,
        background: 'transparent',
        border: 0,
        outline: 'none',
    },
}));
const ClickToEdit = ({ text, variant = 'subtitle1', onTextChange, placeholder = 'Click to edit' }) => {
    const classes = useStyles();
    const [isEditing, setIsEditing] = (0, react_1.useState)(false);
    const [editText, setEditText] = (0, react_1.useState)(text);
    const [containerHeight, setContainerHeight] = (0, react_1.useState)(null);
    const inputRef = (0, react_1.useRef)(null);
    const containerRef = (0, react_1.useRef)(null);
    const typoStyles = totangoTheme_1.totangoTheme.typography[variant] || {};
    // Measure container height on mount and when text changes
    (0, react_1.useEffect)(() => {
        if (containerRef.current) {
            const { height } = containerRef.current.getBoundingClientRect();
            setContainerHeight(height);
        }
    }, [text]);
    // Add effect to update editText when text prop changes
    (0, react_1.useEffect)(() => {
        setEditText(text);
    }, [text]);
    (0, react_1.useEffect)(() => {
        if (isEditing && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.setSelectionRange(text?.length, text?.length);
        }
    }, [isEditing, text]);
    const handleBlur = (0, react_1.useCallback)(() => {
        setIsEditing(false);
        if (editText !== text) {
            onTextChange(editText);
        }
    }, [editText, onTextChange, text]);
    const handleKeyDown = (0, react_1.useCallback)((e) => {
        if (e.key === 'Enter') {
            handleBlur();
        }
        else if (e.key === 'Escape') {
            setEditText(text);
            setIsEditing(false);
        }
    }, [handleBlur, text]);
    const handleChange = (0, react_1.useCallback)((e) => {
        setEditText(e.target.value);
    }, []);
    return (react_1.default.createElement("div", { ref: containerRef, className: classes.container, onClick: () => !isEditing && setIsEditing(true) }, isEditing ? (react_1.default.createElement(core_1.InputBase, { inputRef: inputRef, value: editText, onChange: handleChange, onBlur: handleBlur, onKeyDown: handleKeyDown, placeholder: placeholder, className: `MuiTypography-root MuiTypography-${variant}`, inputProps: {
            style: {
                ...typoStyles,
                lineHeight: typoStyles.lineHeight,
                padding: 0,
                margin: 0,
            },
        }, classes: {
            input: classes.input,
            root: classes.inputRoot,
        }, style: {
            minHeight: containerHeight ? `${containerHeight}px` : 'auto',
        }, fullWidth: true })) : (react_1.default.createElement(core_1.Typography, { variant: variant }, text || placeholder))));
};
ClickToEdit.propTypes = {
    text: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.oneOf([null])]),
    variant: prop_types_1.default.string,
    onTextChange: prop_types_1.default.func.isRequired,
    placeholder: prop_types_1.default.string,
};
ClickToEdit.defaultProps = {
    variant: 'subtitle1',
    text: null,
    placeholder: 'Click to edit',
};
exports.default = ClickToEdit;
//# sourceMappingURL=click-to-edit.js.map